import { ActionContext } from "vuex";
import { RootState } from "./index";
import request from "~/utils/request";
import { feelgoodAuth as api } from "~/const/apis";

interface State {}

export const actions = {
    getToken({
        commit
    }: ActionContext<State, RootState>) {
        return request.get(api.getToken)
    }
}